import DatePicker from "react-datepicker"

export default function DatePickerNoKeyboard({ selected, open, setOpen, onChange, placeholderText, styles = '' }) {
  const defaultStyles = 'bg-grey-900 border-grey focus:border-grey-300'

  return (
    <DatePicker
      selected={selected}
      open={open}
      onChange={(date) => {
        onChange(date)
        setOpen(false)
      }}
      className={`${styles ?? defaultStyles} border-1 p-0.5 w-full focus:ring-0 caret-[transparent] rounded"`}
      placeholderText={placeholderText}
      onSelect={() => setOpen(false)}
      onInputClick={() => setOpen(true)}
      onClickOutside={() => setOpen(false)}
      readOnly
    />
  )
}